











import { Component, Prop, Vue } from "vue-property-decorator";
import CzPage from "../cz/CzPage.vue";
import CzNotice from "../cz/CzNotice.vue";
import CzLink from "../cz/CzLink.vue";

@Component({
  components: { CzPage, CzNotice, CzLink },
})
export default class ProgramPage extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: [String, Object], default: "" }) backTo!: string | object;
  @Prop({ type: String, default: "" }) backLabel!: string;
  @Prop({ type: String, default: "" }) empty!: string;
  @Prop({ type: Boolean, default: false }) embedded!: boolean;
}
